export const ROLE_TYPE_SYSTEM_UUID = '62721ac5-1322-435e-8b86-f2ff56742707';
export const ROLE_TYPE_REAL_ESTATE_UUID = '68a75a4e-4e57-490a-9285-6d5a6ae88a92';
export const ROLE_TYPE_SUPPLIER_UUID = 'c35c9692-4082-4344-959b-84b9742d5b6c';
export const ROLE_CLASSIFICATION_GENERAL_UUID =
  '9b046a1c-d455-4f4e-988d-f610f231e376';
export const ROLE_CLASSIFICATION_SPECIAL_UUID =
  '049f9d90-895f-43b3-80ba-ec9da2da60f4';

export type RoleSelectDto = {
  uuid: string;
  name: string;
};

export type RoleToneDto = {
  name: string;
  value: string;
  tone: string;
};

export type RoleGridDto = {
  uuid: string;
  name: string;
  type: RoleSelectDto;
  classification: RoleSelectDto;
  realEstate: RoleSelectDto | null;
  supplier: RoleSelectDto | null;
  description: string | null;
  status: RoleToneDto;
  protectedRole: boolean;
};

export type RoleDto = RoleGridDto & {
  code: string;
  assigned: boolean;
  createdAt: string;
  updatedAt: string;
};

export type RoleRequest = {
  typeUuid: string;
  classificationUuid: string;
  name: string;
  description: string | null;
  realEstateUuid: string | null;
  supplierUuid: string | null;
};

export type RoleListQuery = {
  page?: number;
  size?: number;
  sortBy?: string;
  order?: 'asc' | 'desc';
  name?: string;
  description?: string;
  realEstate?: string;
  supplier?: string;
  typeUuids?: readonly string[];
  classificationUuids?: readonly string[];
  statusUuids?: readonly string[];
};

export type RoleListResult = {
  items: RoleGridDto[];
  total: number;
};

export type RoleFormSelects = {
  types: RoleSelectDto[];
  classifications: RoleSelectDto[];
  realEstates: RoleSelectDto[];
  suppliers: RoleSelectDto[];
};

export type RoleFilterSelects = {
  types: RoleSelectDto[];
  classifications: RoleSelectDto[];
  statuses: RoleSelectDto[];
};

export type RoleApiDownload = {
  blob: Blob;
  filename: string;
};
